<template>
  <relatorio-page :titulo="'Relatório Avaliação de Beneficiário'" :cabecalhoCompleto="true" :exportarExcel="false" :paisagem="true" :fonteVariavel="true">
    <v-row class="fonte mb-2">
      <v-col cols="12" md="3"><strong>Beneficiário:</strong> {{ BeneficiarioFiltro() }}</v-col>
      <v-col cols="12" md="3"><strong>Período:</strong> {{ Periodo() }}</v-col>
      <v-col cols="12" md="2"><strong>Status:</strong> {{ StatusNome(filter.statusFrequencia) || 'Todos' }}</v-col>
      <v-col cols="12" md="2"><strong>Modelo:</strong> {{ ModeloFiltro() }}</v-col>
      <v-col cols="12" md="2"><strong>Projeto/Resp.:</strong> {{ CodigoOuTodos(filter.projetoId) }} / {{ CodigoOuTodos(filter.usuarioId) }}</v-col>
    </v-row>

    <v-row v-if="modelos.length > 0" class="fonte resumo-geral">
      <v-col cols="12" md="3"><strong>Total de avaliações:</strong> {{ resumo.totalAvaliacoes }}</v-col>
      <v-col cols="12" md="3"><strong>Beneficiários:</strong> {{ resumo.quantidadeBeneficiarios }}</v-col>
      <v-col cols="12" md="2"><strong>Modelos:</strong> {{ modelos.length }}</v-col>
      <v-col cols="12" md="2"><strong>Média geral:</strong> {{ FormatarMedia(resumo.mediaGeral) }}</v-col>
      <v-col cols="12" md="2"><strong>Atrasados:</strong> {{ resumo.atrasados }}</v-col>
    </v-row>

    <v-row v-if="modelos.length > 0">
      <v-col cols="12">
        <div v-for="modelo in modelos" :key="modelo.avaliacaoModeloId" class="modelo-bloco fonte">
          <div class="modelo-titulo" :style="`border-left-color:${modelo.cor || '#607D8B'}`">
            <strong>{{ modelo.nome }}</strong>
            <span class="ml-3">Média: {{ FormatarMedia(modelo.media) }}</span>
            <span class="ml-3">Avaliações: {{ modelo.quantidadeAvaliacoes }}</span>
            <span class="ml-3">Beneficiários: {{ modelo.quantidadeBeneficiarios }}</span>
            <span class="ml-3">Frequência: {{ modelo.frequenciaDias }} dias</span>
            <span class="ml-3">Status: {{ modelo.statusFrequenciaDescricao }}</span>
          </div>

          <div v-for="beneficiario in modelo.beneficiarios" :key="`${modelo.avaliacaoModeloId}-${beneficiario.beneficiarioId}`" class="beneficiario-bloco">
            <div class="beneficiario-titulo">
              <strong>{{ beneficiario.nome }}</strong>
              <span class="ml-3">Matrícula: {{ beneficiario.matricula || '-' }}</span>
              <span class="ml-3">CPF/CNPJ: {{ beneficiario.cpfCnpj || '-' }}</span>
              <span class="ml-3">Média: {{ FormatarMedia(beneficiario.media) }}</span>
              <span class="ml-3">Status: {{ beneficiario.statusFrequenciaDescricao }}</span>
            </div>

            <v-simple-table dense class="py-2 text-caption">
              <template v-slot:default>
                <thead class="fonte" style="background-color: #4A70A8">
                  <tr>
                    <th class="text-left" style="font-size: 100%; color: white">Código</th>
                    <th class="text-left" style="font-size: 100%; color: white">Data</th>
                    <th class="text-left" style="font-size: 100%; color: white">Média</th>
                    <th class="text-left" style="font-size: 100%; color: white">Projeto</th>
                    <th class="text-left" style="font-size: 100%; color: white">Responsável</th>
                    <th class="text-left" style="font-size: 100%; color: white">Itens</th>
                    <th class="text-left" style="font-size: 100%; color: white">Observação</th>
                  </tr>
                </thead>
                <tbody class="fonte">
                  <tr v-for="(avaliacao, index) in beneficiario.avaliacoes" :key="avaliacao.id" :style="index % 2 === 0 ? 'background-color: gainsboro' : 'background-color: white'">
                    <td style="font-size: 100%">{{ avaliacao.id }}</td>
                    <td style="font-size: 100%">{{ Data(avaliacao.dataAvaliacao) }}</td>
                    <td style="font-size: 100%">{{ FormatarMedia(avaliacao.media) }}</td>
                    <td style="font-size: 100%">{{ avaliacao.projeto || 'Sem projeto' }}</td>
                    <td style="font-size: 100%">{{ avaliacao.responsavel || '-' }}</td>
                    <td style="font-size: 100%">
                      <div v-for="item in avaliacao.itens" :key="item.id">
                        {{ item.nome }}: {{ FormatarMedia(item.nota) }}
                      </div>
                    </td>
                    <td style="font-size: 100%">{{ avaliacao.observacao || '-' }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row v-else-if="!overlay">
      <v-col cols="12">Nenhum registro foi encontrado.</v-col>
    </v-row>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </relatorio-page>
</template>

<script>
import { BeneficiarioAvaliacaoService } from '@/core/services/projetos';

export default {
  data: () => ({
    service: new BeneficiarioAvaliacaoService(),
    filter: {},
    modelos: [],
    overlay: false
  }),
  computed: {
    resumo(){
      const beneficiarios = [];
      const avaliacoes = [];

      this.modelos.forEach(modelo => {
        modelo.beneficiarios.forEach(beneficiario => {
          if(!beneficiarios.includes(beneficiario.beneficiarioId))
            beneficiarios.push(beneficiario.beneficiarioId);

          beneficiario.avaliacoes.forEach(avaliacao => avaliacoes.push(avaliacao));
        });
      });

      const totalMedia = avaliacoes.reduce((total, avaliacao) => total + Number(avaliacao.media || 0), 0);

      return {
        totalAvaliacoes: avaliacoes.length,
        quantidadeBeneficiarios: beneficiarios.length,
        mediaGeral: avaliacoes.length > 0 ? totalMedia / avaliacoes.length : 0,
        atrasados: this.modelos.reduce((total, modelo) => total + Number(modelo.quantidadeAtrasadas || 0), 0)
      };
    }
  },
  mounted(){
    this.filter = this.$route.query;
    this.Carregar();
  },
  methods: {
    Carregar(){
      this.overlay = true;
      this.service.Relatorio(this.filter).then(
        res => this.modelos = res.data && res.data.modelos ? res.data.modelos : [],
        err => this.$swal('Aviso', err.response ? err.response.data : err.message, 'error')
      ).finally(() => this.overlay = false);
    },
    BeneficiarioFiltro(){
      if(this.modelos.length > 0 && this.modelos[0].beneficiarios.length == 1 && this.filter.beneficiarioId)
        return this.modelos[0].beneficiarios[0].nome;

      return this.filter.beneficiarioId ? `Código ${this.filter.beneficiarioId}` : 'Todos';
    },
    ModeloFiltro(){
      if(this.modelos.length == 1 && this.filter.avaliacaoModeloId)
        return this.modelos[0].nome;

      return this.filter.avaliacaoModeloId ? `Código ${this.filter.avaliacaoModeloId}` : 'Todos';
    },
    CodigoOuTodos(value){
      return value ? `Código ${value}` : 'Todos';
    },
    Periodo(){
      const inicio = this.filter.dataInicial ? this.Data(this.filter.dataInicial) : '';
      const fim = this.filter.dataFinal ? this.Data(this.filter.dataFinal) : '';

      if(inicio && fim) return `${inicio} a ${fim}`;
      if(inicio) return `A partir de ${inicio}`;
      if(fim) return `Até ${fim}`;
      return 'Todos';
    },
    Data(value){
      return value ? new Date(value).ddmmyyyy() : '-';
    },
    FormatarMedia(value){
      const numero = Number(value || 0);
      return numero.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    },
    StatusNome(value){
      if(value == 'E') return 'Em dia';
      if(value == 'P') return 'Próximo vencimento';
      if(value == 'A') return 'Atrasado';
      return '';
    }
  }
}
</script>

<style>
.modelo-bloco {
  margin-bottom: 18px;
  break-inside: avoid;
}

.modelo-titulo {
  border-left: 6px solid #607D8B;
  background: #e8eef5;
  padding: 8px 10px;
  font-size: 100%;
}

.beneficiario-bloco {
  margin-top: 10px;
  break-inside: avoid;
}

.beneficiario-titulo {
  background: #f1f3f5;
  padding: 6px 8px;
}

.resumo-geral {
  background: #f1f3f5;
  padding: 6px 8px;
  margin-bottom: 8px;
}
</style>
